import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import styled from '@emotion/styled';

import { useAppSelector } from '../../shared/store';

import MainSectionInViewDispatcher from '../components/shared/MainSectionInViewDispatcher';
import { initializeMainSection } from '../slice';
import { isPC } from '../../../util/window/getDevice';

const Container = styled.div<{ isHeightAuto: boolean }>`
  overflow: hidden;
  min-height: ${({ isHeightAuto }) => (!isHeightAuto && isPC ? '20000px' : '100vh')};
`;

export default function MainSectionListContainer() {
  const hasSession = useAppSelector(({ auth }) => auth.hasSession);
  const sectionKeys = useAppSelector(({ main }) => main.sectionKeys);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasSession) {
      return;
    }
    dispatch(initializeMainSection());
  }, [dispatch, hasSession]);

  return (
    <Container isHeightAuto={sectionKeys.length > 1}>
      {sectionKeys.length > 1
        ? sectionKeys.map((sectionKey) => <MainSectionInViewDispatcher key={sectionKey} sectionKey={sectionKey} />)
        : null}
    </Container>
  );
}
